export const MAX_SELECTABLE_ROWS = 1000
